import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';

@injectable()
class CountryOfBusinessRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  getCountry = async (tenant: DataroomTenant): Promise<{ countryId: string | null }> => {
    const request = new Request('business_country.get_country');
    const response = await this.rpc(tenant)
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getCountryByContactId = async (tenant: DataroomTenant, contactId: number): Promise<{ countryId: string | null }> => {
    const request = new Request('business_country.get_by_contact_id', { contactId });
    const response = await this.rpc(tenant)
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  updateCountry = async (tenant: DataroomTenant, countryId: string): Promise<void> => {
    const request = new Request('business_country.update_country', { countryId });
    await this.rpc(tenant)
      .call<RpcSuccess>(request);
  };

  confirmRestrictedCountryIp = async (tenant: DataroomTenant): Promise<void> => {
    const request = new Request('business_country.restricted_ip_confirm');
    await this.rpc(tenant)
      .call<RpcSuccess>(request);
  };
}

export default CountryOfBusinessRepository;
